/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/roles', params);
}

function get(id, params) {
  return api.get(`/roles/${id}`, params);
}

function getPermissions(id, params) {
  return api.get(`/roles/${id}/permissions`, params);
}

function create(params) {
  return api.post('/roles', params);
}

function update(id, params) {
  return api.put(`/roles/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/roles/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

export const rolesService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  getPermissions,
};
